import { render, staticRenderFns } from "./LmsFeedPublish.vue?vue&type=template&id=552c344e"
import script from "./LmsFeedPublish.vue?vue&type=script&lang=js"
export * from "./LmsFeedPublish.vue?vue&type=script&lang=js"
import style0 from "./LmsFeedPublish.vue?vue&type=style&index=0&id=552c344e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports